import { UTSLocale } from "@smile2impress/attraction-constants";

import france from "./france";
import italy from "./italy";
import portugal from "./portugal";
import spain from "./spain";
import uk from "./uk";
import ukraine from "./ukraine";
import us from "./us";

export default {
    [UTSLocale.FRANCE_FR]: france,
    [UTSLocale.ITALY_IT]: italy,
    [UTSLocale.PORTUGAL_PT]: portugal,
    [UTSLocale.SPAIN_ES]: spain,
    [UTSLocale.GB_EN]: uk,
    [UTSLocale.UKRAINE_UK]: ukraine,
    [UTSLocale.US_EN]: us,
    [UTSLocale.NL_NL]: uk,
    [UTSLocale.GERMANY_DE]: uk,
    [UTSLocale.SWEDEN_SE]: uk,
    [UTSLocale.DENMARK_DK]: uk,
};
